import { render } from "./coursemaster.vue?vue&type=template&id=5399a5e4&scoped=true"
import script from "./coursemaster.vue?vue&type=script&lang=js"
export * from "./coursemaster.vue?vue&type=script&lang=js"

import "./coursemaster.vue?vue&type=style&index=0&id=5399a5e4&scoped=true&lang=scss"

import exportComponent from "D:\\CTS_SURAJ\\Edu Katta\\Private\\Edukatta_Private_Managment_UI\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5399a5e4"]])

export default __exports__